import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const CounterpartyCheckCardContent: React.FC<
	CounterpartyCheckCardContent.Props
> = ({ item }) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell =
			item?.cellsForTable?.[ColumnId.CounterpartyCheckCard];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item.checkCard);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item.checkCard,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CounterpartyCheckCardContent {
	interface Props {
		item: Order.Model;
	}
}

export default CounterpartyCheckCardContent;
